import { CheckCircle } from 'lucide-react';
import type { RegistrationType } from '@/lib/constants';

type Props = {
  registrationType: RegistrationType;
};

const CONFIRMATION_MESSAGES: Record<RegistrationType, { title: string; body: string }> = {
  exhibitor: {
    title: 'Exhibitor Application Submitted',
    body: 'Thank you for submitting an exhibitor application form for Converge @ NPS at the Naval Postgraduate School in Monterey, CA, July 22\u201324, 2026.\n\nSpace for exhibitors is limited. Selected organizations will be notified by June 22 and exhibitor fees will be due July 6.',
  },
  nps_project: {
    title: 'Project Submission Received',
    body: 'Thank you for submitting your project for inclusion in Converge @ NPS, July 22 to 24. A member of the NPS Foundation staff will be in touch soon regarding your submission and event participation.',
  },
  attendee: {
    title: 'Registration Submitted',
    body: 'Thank you for submitting registration for Converge @ NPS, July 22 to 24. All registrants are vetted for security purposes. Once verified, you will receive an email confirming your registration approval with instructions for accessing the event app.',
  },
};

export default function RegistrationConfirmation({ registrationType }: Props) {
  const { title, body } = CONFIRMATION_MESSAGES[registrationType];

  return (
    <div className="max-w-lg mx-auto text-center space-y-6 py-12 px-4">
      <div className="flex justify-center">
        <CheckCircle className="h-16 w-16 text-green-500" />
      </div>
      <h1 className="text-2xl font-bold">{title}</h1>
      <div className="text-muted-foreground space-y-4">
        {body.split('\n\n').map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </div>
      <p className="text-sm text-muted-foreground">
        Questions? Email{' '}
        <a href="mailto:converge@npsfoundation.org" className="text-primary underline">
          converge@npsfoundation.org
        </a>
      </p>
    </div>
  );
}
